import styled from 'styled-components';
import { breakpoints, colors, fonts, pxToCssFont } from '@vfit/shared/themes';

export const Container = styled.div`
  margin-top: 32px;
  background-color: ${colors.$ffffff};
  border-radius: 20px;
  padding: 32px 24px;

  @media (min-width: ${breakpoints.tablet}) {
    padding: 32px 40px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    padding: 40px 54px;
  }
`;

export const Paragraph = styled.p`
  margin: 0;
  font-weight: 400;
  color: ${colors.$262626};
`;

export const Title = styled(Paragraph)`
  font-family: ${fonts.exbold};
  ${pxToCssFont(30, 38)}

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(36, 45)}
  }
`;

export const StepsList = styled.ul`
  margin: 0;
  margin-top: 24px;
  padding: 0;
  list-style-type: none;
`;

export const Step = styled.li`
  display: flex;
  align-items: baseline;
  margin-bottom: 8px;

  @media (min-width: ${breakpoints.tablet}) {
    margin-bottom: 16px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const NumberBox = styled.div`
  font-family: ${fonts.regular};
  ${pxToCssFont(24, 28)}
  font-weight: 400;
  color: ${colors.$e60000};

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(24, 30)}
  }
`;

export const Description = styled(Paragraph)`
  margin-left: 16px;

  p {
    margin: 0;
  }

  div {
    margin: 0;
    font-family: ${fonts.regular};
    ${pxToCssFont(18, 24)}
    text-align: left;
  }
`;

export const LinkContainer = styled.div`
  display: flex;

  .linkWithIcon {
    margin-top: 8px;
  }
`;

export const ModalInfoContainer = styled.div`
  padding: 32px 28px;

  @media (min-width: ${breakpoints.tablet}) {
    padding: 0;
  }
`;

export const FirstContent = styled.div`
  margin-top: 32px;

  div {
    margin: 0;
    font-family: ${fonts.regular};
    ${pxToCssFont(18, 24)}
    text-align: left;
  }
`;

export const SecondContent = styled(FirstContent)`
  margin-top: 14px;
`;

